class TabPanel extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      headerNav: this.querySelector('.vbf-tab-panel__header-nav'),
      tabs: Array.from(this.querySelectorAll('[data-tab-panel-el="tab"]')),
      panels: this.querySelectorAll('[data-tab-panel-el="panel"]'),
    }
  }

  connectedCallback() {
    this.initTabs();
    this.setupEventListeners();
  }

  initTabs() {
    this.elements.tabs.forEach((tab, index) => {
      const isSelected = tab.getAttribute('aria-selected') === 'true';
      tab.setAttribute('tabindex', isSelected ? '0' : '-1');
    });
  }

  setupEventListeners() {
    this.elements.tabs.forEach(tab => {
      tab.addEventListener('click', this.handleClick.bind(this));
      tab.addEventListener('keydown', this.handleKeydown.bind(this));
    });

    this.addEventListener('recently-viewed-carousel:empty', this.handleRecentlyViewedEmpty.bind(this));
  }

  handleClick(event) {
    this.selectTab(event.target);
  }

  handleRecentlyViewedEmpty(event) {
    this.elements.tabs[0].click();

    const closestPanel = event.target.closest('[data-tab-panel-el="panel"]');
    const relatedTab = this.elements.tabs.find(tab => tab.getAttribute('aria-controls') === closestPanel.id);

    relatedTab.setAttribute('hidden', '');
  }

  handleKeydown(event) {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') {
      return;
    }
    event.preventDefault();

    const currentTab = event.target;
    const currentIndex = this.elements.tabs.indexOf(currentTab);

    let newIndex;
    if (event.key === 'ArrowRight') {
      newIndex = (currentIndex + 1) % this.elements.tabs.length;
    } else if (event.key === 'ArrowLeft') {
      newIndex = (currentIndex - 1 + this.elements.tabs.length) % this.elements.tabs.length;
    }

    const newTab = this.elements.tabs[newIndex];
    newTab.focus();
    this.selectTab(newTab);
  }

  selectTab(tab) {
    const panelID = tab.getAttribute('aria-controls');
    const panel = this.querySelector(`#${panelID}`);

    this.elements.tabs.forEach(t => {
      t.setAttribute('aria-selected', 'false');
      t.setAttribute('tabindex', '-1');
    });

    this.elements.panels.forEach(p => {
      p.setAttribute('hidden', '');
    });

    tab.setAttribute('aria-selected', 'true');
    tab.setAttribute('tabindex', '0');
    panel.removeAttribute('hidden');
  }
}

customElements.define('tab-panel', TabPanel, { extends: 'section' });
